import {Component, OnInit} from '@angular/core';

//https://www.w3schools.com/js/js_cookies.asp
function getCookie(cname: string): string {
    const name = cname + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

@Component({
    selector: 'app-tronity-landing',
    templateUrl: './tronity-landing.component.html',
    styleUrls: ['./tronity-landing.component.scss']
})
export class TronityLandingComponent implements OnInit {
    success: boolean;
    link: string = "/";

    constructor() {
        this.success = (/.*tronityOk/.test(window.location.href));
        const fid = getCookie("fleetId")
        const cid = getCookie("customerId")
        if (!fid && !cid) {
            this.link = "/";
        } else if (!cid) {
            this.link = "/?cid=" + cid
        } else if (!fid) {
            this.link = "/?fid=3&cid=4"
        } else {
            this.link = "/?fid=" + fid + "&cid=" + cid
        }
    }

    ngOnInit(): void {
    }

}
